<app-maintenance-banner [message]="maintenanceBanner"></app-maintenance-banner>
<div class="login-page">
  <div class="login-lang-picker">
    <app-language-select
      variant="compact"
      [value]="languageService.currentLang()"
      (valueChange)="selectLang($event)"
      [ariaLabel]="'auth.login.language' | translate"
    ></app-language-select>
  </div>
  <div class="card">
    <div class="brand">
      <img src="/assets/logo-horizontal.svg" alt="Waitora" class="brand-icon" />
    </div>

    <div class="error" *ngIf="sessionExpired">
      {{ 'auth.login.sessionExpired' | translate }}
    </div>

    <!-- ngSubmit + click pour être sûr à 100% -->
    <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <label class="label">{{ 'auth.login.emailLabel' | translate }}</label>
      <input
        class="input"
        type="email"
        formControlName="email"
        placeholder="xxx@xxx"
        autocomplete="email"
      />
      <div class="error" *ngIf="form.get('email')?.touched && form.get('email')?.invalid">
        {{ 'auth.login.emailInvalid' | translate }}
      </div>

      <label class="label">{{ 'auth.login.passwordLabel' | translate }}</label>
      <div class="password-field">
        <input
          class="input"
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          placeholder="••••••••"
          autocomplete="current-password"
        />
        <button 
          type="button" 
          class="password-toggle" 
          (click)="togglePasswordVisibility()"
          tabindex="-1"
        >
          <svg *ngIf="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
          <svg *ngIf="showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
            <line x1="1" y1="1" x2="23" y2="23"/>
          </svg>
        </button>
      </div>
      <div class="error" *ngIf="form.get('password')?.touched && form.get('password')?.invalid">
        {{ 'auth.login.passwordInvalid' | translate }}
      </div>

      <a class="link" href="#" (click)="openForgotPasswordModal(); $event.preventDefault()">{{ 'auth.login.forgotPassword' | translate }}</a>

      <p class="error api" *ngIf="apiError">{{ apiError }}</p>

      <button
        class="btn primary"
        type="submit"
        [disabled]="loading || form.invalid"
      >
        {{ loading ? ('auth.login.submitLoading' | translate) : ('auth.login.submit' | translate) }}
      </button>

      <button class="btn secondary" type="button" (click)="toRegister()">
        {{ 'auth.login.register' | translate }}
      </button>
    </form>
  </div>

  <!-- Modale Mot de passe oublié -->
  <div class="modal-overlay" *ngIf="showForgotPasswordModal" (click)="closeForgotPasswordModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ 'auth.login.forgotModal.title' | translate }}</h3>
        <button class="close-btn" (click)="closeForgotPasswordModal()">&times;</button>
      </div>

      <div class="modal-body" *ngIf="!forgotPasswordSuccess">
        <p>{{ 'auth.login.forgotModal.instructions' | translate }}</p>
        <input
          class="input"
          type="email"
          [(ngModel)]="forgotPasswordEmail"
          placeholder="votre@email.com"
          [disabled]="forgotPasswordLoading"
        />
      </div>

      <div class="modal-body" *ngIf="forgotPasswordSuccess">
        <p class="success-message">{{ 'auth.login.forgotModal.successMessage' | translate:{ email: forgotPasswordEmail } }}</p>
      </div>

      <div class="modal-footer">
        <button
          class="btn secondary"
          (click)="closeForgotPasswordModal()"
          *ngIf="!forgotPasswordSuccess"
        >
          {{ 'auth.login.forgotModal.cancel' | translate }}
        </button>
        <button
          class="btn primary"
          (click)="sendResetEmail()"
          [disabled]="!forgotPasswordEmail || forgotPasswordLoading"
          *ngIf="!forgotPasswordSuccess"
        >
          {{ forgotPasswordLoading ? ('auth.login.forgotModal.sending' | translate) : ('auth.login.forgotModal.send' | translate) }}
        </button>
        <button
          class="btn primary"
          (click)="closeForgotPasswordModal()"
          *ngIf="forgotPasswordSuccess"
        >
          {{ 'auth.login.forgotModal.close' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modale Mot de passe Admin -->
  <div class="modal-overlay" *ngIf="showAdminModal" (click)="closeAdminModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ 'auth.login.adminModal.title' | translate }}</h3>
        <button class="close-btn" (click)="closeAdminModal()">&times;</button>
      </div>

      <div class="modal-body">
        <p>{{ 'auth.login.adminModal.instructions' | translate }}</p>
        <input
          class="input"
          type="password"
          [(ngModel)]="adminPassword"
          [placeholder]="'auth.login.adminModal.passwordPlaceholder' | translate"
          (keyup.enter)="validateAdminPassword()"
        />
        <div class="error" *ngIf="adminError">
          {{ 'auth.login.adminModal.error' | translate }}
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn secondary" (click)="closeAdminModal()">
          {{ 'auth.login.adminModal.cancel' | translate }}
        </button>
        <button
          class="btn primary"
          (click)="validateAdminPassword()"
          [disabled]="!adminPassword"
        >
          {{ 'auth.login.adminModal.validate' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>